import React from 'react';
import c from 'classnames';
import CorePrice from '../../CorePrice';
import { usePackagePickerOrder } from '../../hooks';

import s from './SecondaryCTA.scss';

export interface Props {}

const SecondaryCTA: React.FC<Props> = () => {
  const packagePickerOrder = usePackagePickerOrder();

  return (
    <div className={c(s['root'])}>
      {packagePickerOrder.map(coreType => (
        <CorePrice key={coreType} coreType={coreType} />
      ))}
    </div>
  );
};
SecondaryCTA.displayName = 'SecondaryCTA';

export default SecondaryCTA;
